import { facts } from "./constants";

export interface Widget {
  id: string;
  name: string;
  onClick: () => void;
  type?: string;
  disable?: boolean;
}

export interface Message {
  type: "bot" | "user";
  message: any;
  buttons?: Widget[];
}

export interface HomeOrAway {
  id: number;
  name: string;
  code: string;
}
export interface Toast {
  message: string;
  type: string;
}

export interface IPLMatchInterface {
  id: string;
  series_id: number;
  venue: string;
  date: string;
  status: string;
  result: string;
  match_title: string;
  match_subtitle: string;
  home: HomeOrAway;
  away: HomeOrAway;
  predictions: any;
}

export interface EmployeeTrainingData {
  emp_id: number;
  ojt: number;
  classroom: number;
  behavioural: number;
  linkedin: number;
  mandatory_training: number;
  hr_induction: number;
  total_training_hrs: number;
  total_manday_training: number;
}

export interface AwardWinners {
  id: number;
  emp_name: string;
  department: string;
  description: string;
  heading: string;
  date?: string;
}

export interface Percentage {
  answer_value: "Very Happy";
  count: 2;
  percentage: 33;
}

export interface MoodScoreResponse {
  answer: {
    answer_id: number;
    option_id: number;
    question_id: number;
    emp_id: number;
    answer_value: string;
    answer_date: string;
    comments: string;
    creationdate: string;
    lastmodifieddate: string;
  };
  percentages: Percentage[];
}

export interface CalendarEvent {
  id: number;
  event_title: string;
  event_description: string;
  event_date: string;
  status: string;
  creationdate: string;
  lastmodifieddate: string;
}

export const baseURL = process.env.REACT_APP_BACKEND_URL;

export const iplURL = process.env.REACT_APP_IPL_URL;

export function maskEmail(email: string): string {
  const [name, domain] = email.split("@");
  const nameLength = name.length;
  const maskedName = name[0] + "****" + name[nameLength - 1];
  const maskedMail = maskedName + "@" + domain;
  return maskedMail;
}
export const toBase64 = (file: any): any =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export function getRandomFact(): string {
  let length = facts.length;
  let random = Math.floor(Math.random() * (length + 1));
  return facts[random];
}

export function abbreviateTeamName(teamName: string) {
  const words = teamName?.split(" ");
  const abbreviated = words?.map((word) => word[0]?.toUpperCase())?.join("");
  return abbreviated;
}

export function getHoursDifference(startDate: Date, endDate: Date) {
  const msDiff = Math.abs(endDate.getTime() - startDate.getTime());
  return Math.ceil(msDiff / 36e5);
}

export function isSameDate(firstDate: Date, secondDate: Date) {
  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
}
